import { useCallback } from 'react';
import { DoubleSide } from 'three';
import ShaderEclipse from './ShaderEclipse';
import animation from './eclipse.animation.json';
import { parallax } from '@immutabl3/alchemy/three';

export default function Eclipse({
  nodes,
  ...fogParams
}) {
  const onAnimation = useCallback((mesh, { animations }) => {
    const [{ currentValue: visible }] = animations;
    mesh.visible = !!visible;
  }, []);

  return (
    <parallax.mesh
      beaker="chapter1"
      animation={ animation }
      onAnimation={ onAnimation }

      name="eclipse_planet"
      geometry={ nodes.eclipse_planet.geometry }
      position={ [-15, -136.76, -800.13] }
      rotation={ [-0.22, -0.01, 0] }
      scale={ 1.5 }
    >
      <ShaderEclipse { ...fogParams } />
      <mesh
        name="eclipse_ring"
        geometry={ nodes.eclipse_ring.geometry }
        position={ [0, 1.09, 0] }
      >
        <meshStandardMaterial
          emissive={ [2, 0.01, 0] }
          emissiveIntensity={ 20 }
          side={ DoubleSide }
          fog={ false }
        />
      </mesh>
    </parallax.mesh>
  );
};